import { CREDITS_ACTION_WHATSAPP_CONTENT_SHARED } from '../../../../credits-config';
import { getCreditsHistoryByType } from '../../../../util/user';

/**
 * Sort awards by active action in the following order:
 * from left to right, the next unrevealed award or the active primary button is always visible.
 */
export const sortAwardsByActiveAction = (awards, isMobile) => {
    if (!awards || awards.length < 2) return awards;

    const indexToPasteActiveAward = isMobile ? 0 : 1;

    if (awards[indexToPasteActiveAward].actionAllowed) return awards;

    const indexWithActiveAction = awards.findIndex(aw => Boolean(aw.actionAllowed));

    if (indexWithActiveAction >= 0) {
        const awardToPasteIntoIndex = awards.splice(indexWithActiveAction, 1);
        awards.splice(indexToPasteActiveAward, 0, awardToPasteIntoIndex[0]);
    }

    return awards;
};

export const getShareViaWhatsAppCurrentEvents = currentUser => {
    const creditsHistoryByType = getCreditsHistoryByType(currentUser);
    return creditsHistoryByType.filter(
        creditEntity => creditEntity?.eventName === CREDITS_ACTION_WHATSAPP_CONTENT_SHARED
    );
};
